<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> جستجوی سفرها  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- راننده -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> راننده </label>

            <select class="form-select" formControlName="strUnitID">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of list_Driver" [value]="item.strUnitID">

                    {{item.strFullName}}

                </option>

            </select>

        </div>
        
        <!-- وضعیت -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> وضعیت </label>

            <select class="form-select" formControlName="tiTripStatus">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of list_TripStatus" [value]="item.tiTripStatus">

                    {{item.strComment}}

                </option>

            </select>

        </div>
        
        <!-- کاربر سازمانی -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> کاربر سازمانی </label>

            <select class="form-select" formControlName="iSystemUser_User">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of list_SystemUser" [value]="item.iSystemUser">

                    {{item.strFullName}}

                </option>

            </select>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Trip()"> جستجو </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')"> 

                خروجی اکسل
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2" >

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-md-11 col-12 px-2">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

                <button class="btn btn-warning w-100" (click)="showMap()"> 

                    نقشه

                </button>
    
            </div>

        </div>
        
        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>
    
                        <th class="text-center"> کد سفر  </th>
    
                        <th class="text-center"> تاریخ سفر  </th>
                        
                        <th class="text-center"> کاربر سازمانی  </th>

                        <th class="text-center"> مبداء  </th>
    
                        <th class="text-center"> مقصد </th>
        
                        <th class="text-center"> مسافر </th>
                
                        <th class="text-center"> موبایل مسافر </th>
        
                        <th class="text-center"> راننده </th>

                        <th class="text-center"> موبایل راننده </th>
                        
                        <th class="text-center"> وضعیت </th>

                        <th class="text-center"> کرایه(ریال) </th>

                        <th class="text-center"> کمیسیون(ریال) </th>

                        <th class="text-center"> پیش پرداخت(ریال) </th>

                        <th class="text-center"> بدهکاری/پستانکاری(ریال) </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Trips;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        
                        <th class="">

                            <i class="fa fa-map-marker mx-2 fs-5 pointer" title="مسیر" (click)="showTripRoute(item)"></i>

                            <i class="fa fa-info-circle fs-5 pointer" title="مشخصات" (click)="newRequest(item,i,'showMode')"></i>
                           
                        </th>

                        <td> {{ item.iTaxiLon_Trip | faNum }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strSystemUser_FullName,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strSCityName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strDCityName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobile,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strDriver_FullName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strDriver_Mobile,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strTaxiLon_TripStatus_strComment,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.iFinalRent | number:'1.0-0' | faNum }} </td>

                        <td> {{ item.iCommission | number:'1.0-0' | faNum }} </td>

                        <td> {{ item.iAdvancePayment | number:'1.0-0' | faNum }} </td>

                        <td dir="ltr"> {{ item.iDebitCredit | number:'1.0-0' | faNum }} </td>

                    </tr>

                </tbody>
    
            </table>
    
        </div>

        <div class="row gx-0 gy-0 p-2 bg-secondary">

            <span class="col-md-auto col-12 text-white"> سرجمع کرایه : {{ iFinalRent | number:'1.0-0' | faNum }} ریال </span>

            <span class="col-md-auto col-12 text-white mx-md-5"> سرجمع کمیسیون : {{ iCommission | number:'1.0-0' | faNum }} ریال </span>

            <span class="col-md-auto col-12 text-white"> سرجمع بدهکاری/پستانکاری : <span dir="ltr"> {{ iDebitCredit | number:'1.0-0' | faNum }} ریال </span> </span>

        </div>

    </div>

    <!-- مدال مشاهده اطلاعات -->

    <div class="modal fade" id="newReq_Modal">
        
        <div class="modal-dialog modal-lg modal-fullscreen-sm-down">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> 

                        {{ bEditMode == true ? 'ویرایش سرویس' : bEditMode == 'showMode' ? 'مشاهده اطلاعات' : 'افزودن سرویس'  }}
                        
                    </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body disabled-child" style="max-height: 76vh;overflow: auto;">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-md-0 gy-2 p-2">

                        <!-- موبایل مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> موبایل مسافر </label>
                
                            <input class="form-control p-2 text-end"
                            
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                                maxlength="11"

                                formControlName="strMobile">

                
                        </div>

                        <!-- نام مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام مسافر </label>
                
                            <input class="form-control p-2 text-center" formControlName="strName">
                
                        </div>

                        <!-- نام خانوادگی مسافر -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام خانوادگی مسافر </label>
                
                            <input class="form-control p-2 text-center" formControlName="strFamily">
                
                        </div>

                        <!-- جنسیت -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> جنسیت </label>
                
                            <select class="form-select p-2" formControlName="tiSex">
                
                                <option class="text-center" [value]="1"> مرد </option>

                                <option class="text-center" [value]="1"> زن </option>
                
                            </select>
                
                        </div>
                        
                        <!-- کد ملی -->

                        <ng-container *ngIf="!isCity">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> کد ملی </label>
                    
                                <input class="form-control p-2 text-center"
                                
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
    
                                    maxlength="10"
    
                                    formControlName="strID">
                    
                            </div>

                        </ng-container>

                        <!-- تاریخ سفر -->
                
                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> تاریخ سفر </label>
                
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                
                                <input formControlName="strDate" class="form-control p-2 text-end" />
                
                            </ng-persian-datepicker>
                
                        </div>

                        <!-- ساعت سفر -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted" style="z-index: 10;"> ساعت سفر </label>

                            <div class="input-group clockpicker">

                                <input type="text" class="form-control p-2 text-center" id="strTime_" formControlName="strTime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- تعداد مسافر -->

                        <ng-container *ngIf="!isCity">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> تعداد مسافر </label>
                    
                                <input class="form-control p-2 text-center"
                                
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
    
                                    maxlength="2" formControlName="tiPassenger">
    
                            </div>

                            <!-- جدا کننده -->

                            <div class="position-relative col-0 col-md-4 p-2">

                            </div>

                        </ng-container>

                        <!-- شهر مبداء -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مبداء </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || bEditMode == 'searchMode' || isCity ? 'strCity' : 'strSCity', mdl_Request.get('strSCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_Request.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strSCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مبداء -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مبداء </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مبداء خود را جستجو کنید ...' "
                            
                                formControlName="strSAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>

                    
                        </div>
                        
                        <!-- شهر مقصد -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> شهر مقصد </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue(bEditMode || isCity ? 'strCity' : 'strDCity',mdl_Request.get('strDCity')?.value,lst_City,'strCityName')"
                        
                                [strComment]="'strCityName'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: start']"
                        
                                [str_Placeholder]="' جستجو کنید...'"
                        
                                [lst_Main]="lst_City" 
                        
                                [lst_SearchKey]="['strCityName']"
                        
                                [isDisabled]="mdl_Request.disabled || isCity && Selected_City != '' ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strDCity')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- آدرس مقصد -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> آدرس مقصد </label>

                            <input class="form-control p-2 text-start" 

                                [placeholder]="isCity ? 'تهران، خیابان ولیعصر' : 'آدرس مقصد خود را جستجو کنید ...' "
                            
                                formControlName="strDAddress">    

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')">

                                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>
                                               
                        </div>

                        <!-- تاکسی بین شهری -->

                        <ng-container *ngIf="!isCity">

                            <!-- سرویس برای دیگری -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bForAnother')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bForAnother" formControlName="bForAnother">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bForAnother"> سرویس برای دیگری </label>
                                
                                </div>
    
                            </ng-container>
                                                    
                            <!-- نام و نام خانوادگی متقاضی -->
    
                            <div *ngIf="mdl_Request.get('bForAnother')?.value" class="position-relative col-12 col-md-12 p-2">
    
                                <ng-container *ngIf="mdl_Request.get('bForAnother')?.value">
                   
                                    <label class="mb-2 text-muted"> نام و نام خانوادگی متقاضی </label>
                        
                                    <input class="form-control p-2 text-start" formControlName="strPassengersName">
    
                                </ng-container>
                    
                            </div>
    
                            <!-- سرویس شامل بار می باشد -->
    
                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCargo')?.value || bEditMode != 'showMode'">
    
                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bCargo" formControlName="bCargo">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bCargo"> سرویس شامل بار می باشد </label>
                                
                                </div>
    
                            </ng-container>
                            
                            <!-- توضیحات بار -->
    
                            <div *ngIf="mdl_Request.get('bCargo')?.value" class="position-relative col-12 col-md-12 p-2">
    
                                <ng-container *ngIf="mdl_Request.get('bCargo')?.value">
                   
                                    <label class="mb-2 text-muted"> توضیحات بار </label>
                        
                                    <input class="form-control p-2 text-start" formControlName="strCargoDetail">
    
                                </ng-container>
                    
                            </div>

                        </ng-container>

                        <!-- دارای توقف -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bHasStop')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bHasStop" formControlName="bHasStop">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bHasStop"> توقف دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- مدت توقف -->

                        <div *ngIf="mdl_Request.get('bHasStop')?.value" class="position-relative col-12 col-md-12 p-2">

                            <ng-container *ngIf="mdl_Request.get('bHasStop')?.value">

                                <label class="mb-2 text-muted"> مدت توقف </label>
                
                                <input class="form-control p-2"

                                    placeholder="مدت زمان توقف را وارد کنید مانند : 2.5 ساعت"

                                    [ngClass]="mdl_Request.get('fEstimateStop')?.value != '' ? 'text-center' : 'text-start'"

                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                
                                    formControlName="fEstimateStop">

                            </ng-container>
                                
                        </div>

                        <!-- رفت و برگشت -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bCameBack')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bCameBack" formControlName="bCameBack">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bCameBack"> رفت و برگشت </label>
                            
                            </div>

                        </ng-container>

                        <!-- حیوان خانگی دارد -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bPet')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bPet" formControlName="bPet">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bPet"> حیوان خانگی دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- سیگار مجاز -->

                        <ng-container *ngIf="!isCity">

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bSmoking')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                    <input class="form-check-input m-0" type="checkbox" id="bSmoking" formControlName="bSmoking">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bSmoking"> سیگار مجاز </label>
                                
                                </div>

                            </ng-container>

                        </ng-container>

                        <!-- مسافر نیاز به کمک دارد -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bNeedHelp')?.value || bEditMode != 'showMode'">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bNeedHelp" formControlName="bNeedHelp">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bNeedHelp"> مسافر نیاز به کمک دارد </label>
                            
                            </div>

                        </ng-container>

                        <!-- تاکسی بین شهری -->

                        <ng-container *ngIf="!isCity">

                            <!-- متقاضی فاکتور -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bInvoiceRequired')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">
    
                                    <input class="form-check-input m-0" type="checkbox" id="bInvoiceRequired" formControlName="bInvoiceRequired">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bInvoiceRequired"> متقاضی فاکتور </label>
                                
                                </div>
    
                            </ng-container>

                            <!-- نام شرکت -->

                            <div *ngIf="mdl_Request.get('bInvoiceRequired')?.value" class="position-relative col-12 p-2">
                    
                                <label class="mb-2 text-muted"> نام شرکت </label>
                    
                                <input placeholder="جهت صدور فاکتور نام شرکت مورد نظر را وارد کنید" class="form-control p-2 text-start" formControlName="strCompany">
                    
                            </div>

                            <!-- مسافر غیر ایرانی -->

                            <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('bForeigner')?.value || bEditMode != 'showMode'">

                                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                    <input class="form-check-input m-0" type="checkbox" id="bForeigner" formControlName="bForeigner">
                                
                                    <label class="form-check-label pointer text-muted me-2" for="bForeigner"> مسافر غیر ایرانی </label>
                                
                                </div>

                            </ng-container>
                            
                            <!-- شماره پاسپورت -->

                            <div *ngIf="mdl_Request.get('bForeigner')?.value" class="position-relative col-12 p-2">
                    
                                <label class="mb-2 text-muted"> شماره پاسپورت </label>
                    
                                <input placeholder="شماره پاسپورت مسافر غیر ایرانی را وارد کنید" class="form-control p-2 text-start" formControlName="strPassportNumber">
                    
                            </div>

                        </ng-container>
                                                
                        <!-- گروه خودرویی -->

                        <div [ngClass]="mdl_Request.get('_fKm')?.value != '' || bEditMode ? 'col-md-4' : 'col-md-6' " class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> گروه خودرویی </label>
                
                            <select class="form-select p-2" formControlName="tiMobileGroup" >
                
                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GroupCar" [value]="item.tiMobileGroup">

                                    {{item.strComment}}
                
                                </option>
                
                            </select>
                
                        </div>

                        <!-- مبلغ -->

                        <div [ngClass]="mdl_Request.get('_fKm')?.value != '' || bEditMode ? 'col-md-4' : 'col-md-6' " class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> مبلغ(ریال) </label>
                
                            <input class="form-control p-2 text-center"
                            
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                    
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                                [value]="putSeprator(mdl_Request.get('iEstimateRent')?.value,bEditMode) "

                                formControlName="iEstimateRent">

                            <ng-container *ngIf="bEditMode != 'showMode'">

                                <button class="btn btn-primary rounded" (click)="calc_Renting()">

                                    <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
                                
                                </button>

                            </ng-container>

                
                        </div>

                        <!-- مسافت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != ''">

                            <div class="position-relative col-12 col-md-4 p-2" style="pointer-events: none;">
                
                                <label class="mb-2 text-muted"> مسافت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="_fKm">
                    
                            </div>

                        </ng-container>

                        <!-- مدت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != ''">

                            <div class="position-relative col-12 col-md-4 p-2" style="pointer-events: none;">
                
                                <label class="mb-2 text-muted"> مدت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="_strTime">
                    
                            </div>

                        </ng-container>

                        <!-- درصد کمسیون -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != '' || bEditMode">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> درصد کمسیون </label>
                    
                                <input class="form-control p-2 text-center" formControlName="tiCommissionPercentage">
                    
                            </div>

                        </ng-container>

                        <!-- مقدار پیش پرداخت -->

                        <ng-container *ngIf="mdl_Request.get('_fKm')?.value != '' || bEditMode">

                            <div class="position-relative col-12 col-md-4 p-2">
                
                                <label class="mb-2 text-muted"> مقدار پیش پرداخت </label>
                    
                                <input class="form-control p-2 text-center" formControlName="iAdvancePayment">
                    
                            </div>

                        </ng-container>

                        <!-- توضیحات -->
                
                        <div class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> توضیحات </label>
                
                            <textarea style="height: 48px;resize: none;" class="form-control" formControlName="strComment"></textarea>
                
                        </div>

                        <!-- مشخصات راننده -->

                        <ng-container *ngIf="bEditMode == 'showMode' && mdl_Request.get('strUnitID')?.value != ''">

                            <!-- شناسه خودرو -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted"> شناسه خودرو </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strUnitID">
                    
                            </div>

                            <!-- نام راننده -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted">نام راننده </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strDriver_FullName">
                    
                            </div>

                            <!--  موبایل راننده -->

                            <div class="position-relative col-12 col-md-3 p-2">
                    
                                <label class="mb-2 text-muted"> موبایل راننده </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strDriver_Mobile">
                    
                            </div>

                        </ng-container>
                
                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">

                    <!-- بستن -->
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>

    </div>


</main>